// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

import menuItem from './menu_item';

type Props = {
    to: string;
    text: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    'data-testid'?: string;
}
export const MenuItemExternalLinkImpl: React.FC<Props> = ({to, text, onClick, 'data-testid': dataTestId}: Props) => (
    <a
        data-testid={dataTestId}
        target='_blank'
        rel='noopener noreferrer'
        href={to}
        onClick={onClick}
    >
        <span className='MenuItem__primary-text'>
            {text}
        </span>
    </a>
);

const MenuItemExternalLink = menuItem(MenuItemExternalLinkImpl);
MenuItemExternalLink.displayName = 'MenuItemExternalLink';
export default MenuItemExternalLink;
